import HttpFactory from 'http-service-v3'
export default function advertiserMerchantFactory() {
    const http = HttpFactory()
    return {
      getShopStatus(shopURL) {
        return http
          .get(http.wsaDomain + `/advertisermerchant/v2/shopify/getshopstatus/${shopURL}`)
          .then(response => {
            if (response.data && response.data.data) {
              response.data.data = JSON.parse(response.data.data)
            }
            return response.data 
          })
      },
      getShopStatusByConnectionCode(connectionCode) {
        return http
          .get(http.wsaDomain + `/advertisermerchant/v2/shopify/getshopstatusbycode/${connectionCode}`)
          .then(response => {
            if (response.data && response.data.data) {
              response.data.data = JSON.parse(response.data.data)
            }
            return response.data 
          })
      },
    }
  }